/**
 * O segredo do link do autocadastro (P-ACE-2) vem no fragmento do endereco
 * (#token=...), que o navegador nao envia a servidor nenhum: nao aparece em registro de
 * acesso nem em cabecalho de origem.
 */
export function segredoDoLink(fragmento: string): string {
  return new URLSearchParams(fragmento.replace(/^#/, '')).get('token') ?? '';
}
